import type {} from '@angular/localize/init';
import { appRoutesI18nCache } from '../i18n-cache';

export function tournamentsRouteI18n(): string {
  return (appRoutesI18nCache['tournaments'] ??= $localize`:url-segment@@tournaments-url-segment:tournaments`);
}
